<script>
export default {
    name: "UserListingCreate",

    data() {

      return {
          active: 1,
          activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
          inActiveClass: `bg-gray-300 border-l border-r border-t`,
          roles: [],
        };
    },

    components: {

      //'add-users': () => import('./list/AddUser.vue'),
      'pending-users': () => import('./list/Pending.vue'),
      'approved-users': () => import('./list/Approved.vue'),
      // 'dormant-users': () => import('./list/Dormant.vue'),
      // 'currently-logged-users': () => import('./list/CurrentlyLoggedOn.vue'),
      // 'archived-users': () => import('./list/Archived.vue'),
      // 'user-form': () => import('./Form.vue'),
    },
}  
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
              <template v-slot:card-header>
                <h5 class="font-medium text-sm">Users</h5>
              </template>
              <template v-slot:card-body>
                  <!-- <user-form @refreshData="$refs.pendingUsers.fetchNotApproved()"></user-form> -->
                  <ul class="flex border-b">
                    <!-- <li class="-mb-px mr-1">
                      <a @click.prevent="active=0" 
                        class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                        :class="active==0 ?  activeClass : inActiveClass" href="javascript:void(0)">Add User</a>
                    </li>  -->
                    <li class="-mb-px mr-1">
                      <a @click.prevent="active=1" 
                        class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                        :class="active==1 ?  activeClass : inActiveClass" href="javascript:void(0)">Add User</a>
                    </li>
                    <li class="-mb-px mr-1">
                      <a @click.prevent="active=2" 
                        class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                        :class="active==2 ? activeClass : inActiveClass" href="javascript:void(0)">Users</a>
                    </li>
                    <!-- <li class="-mb-px mr-1">
                      <a @click.prevent="active=3" 
                        class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                        :class="active==3 ? activeClass : inActiveClass" href="javascript:void(0)">Dormant </a>
                    </li>
                    <li class="-mb-px mr-1">
                      <a @click.prevent="active=4" 
                        class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                        :class="active==4 ? activeClass : inActiveClass" href="javascript:void(0)">Archived/Diactivated </a>
                    </li>
                    <li class="-mb-px mr-1">
                      <a @click.prevent="active=5" 
                        class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                        :class="active==5 ? activeClass : inActiveClass" href="javascript:void(0)">Currently Logged In</a>
                    </li> -->
                  </ul>
                  <!-- <div v-if="active==0">
                    <add-users ref="pendingUsers"/>
                  </div> -->
                   <div v-if="active==1">
                    <pending-users ref="pendingUsers"/>
                  </div>
                  <div v-if="active==2">
                      <approved-users/>
                  </div>
                  <div v-if="active==3">
                      <dormant-users/>
                  </div>
                  <div v-if="active==4">
                      <archived-users/>
                  </div>
                  <div v-if="active==5">
                      <currently-logged-users/>
                  </div>
              </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
